export default __webpack_public_path__ + "static/media/roadmap-1.b8be57f2.svg";